import { PAGELEN_QUERY_PARAM } from './constants';
import { buildQueryString } from './utils';

export const urls = {
  api: {
    internal: {
      getPackagesAvailability: (workspaceSlug: string) =>
        `/!api/internal/packages/workspaces/${workspaceSlug}/availability`,
      immutableTagSettings: (workspaceSlug: string) =>
        `/!api/internal/workspaces/${workspaceSlug}/packages-config/container/immutable-tag-settings`,
      immutableTagRules: (workspaceSlug: string) =>
        `/!api/internal/workspaces/${workspaceSlug}/packages-config/container/immutable-tag-rules`,
      immutableTagRulesTest: (workspaceSlug: string) =>
        `/!api/internal/workspaces/${workspaceSlug}/packages-config/container/immutable-tag-rules-test`,
      immutableTagRule: (workspaceSlug: string, ruleUuid: string) =>
        `/!api/internal/workspaces/${workspaceSlug}/packages-config/container/immutable-tag-rules/${ruleUuid}`,
    },
    v20: {
      getAdminRepositories: (workspaceSlug: string, search: string) => {
        const filter =
          'values.uuid,values.full_name,values.name,values.slug,values.project.name';
        // '~' is case-insensitive contains
        const q = search
          ? `slug ~ "${search}" OR name ~ "${search}"`
          : undefined;

        const queryString = buildQueryString({
          [PAGELEN_QUERY_PARAM]: '20',
          role: 'admin',
          filter,
          q,
        });

        return `/!api/2.0/repositories/${workspaceSlug}?${queryString}`;
      },
    },
  },
  external: {
    bitbucketPlansAndPricing:
      'https://www.atlassian.com/software/bitbucket/pricing',
  },
  docs: {
    setupAndUsePackages:
      'https://support.atlassian.com/bitbucket-cloud/docs/set-up-and-use-packages/',
    // This will get redirected to a container package specific doc when it's ready and we will
    // update the link then https://softwareteams.atlassian.net/browse/BCAT-7758
    gettingStartedWithPackages:
      'https://support.atlassian.com/bitbucket-cloud/docs/getting-started-with-packages/',
    workingWithNpmRegistry:
      'https://support.atlassian.com/bitbucket-cloud/docs/working-with-the-npm-registry/',
    workingWithMavenRegistry:
      'https://support.atlassian.com/bitbucket-cloud/docs/working-with-the-apache-maven-registry/',
    workingWithNugetRegistry:
      'https://support.atlassian.com/bitbucket-cloud/docs/working-with-the-nuget-registry/',
    deleteContainerImageDocs:
      'https://support.atlassian.com/bitbucket-cloud/docs/delete-a-container-image-and-tag/',
    linkWorkspaceToOrg: 'https://admin.atlassian.com/',
    linkWorkspaceToOrgGuide:
      'https://community.atlassian.com/forums/Bitbucket-articles/Calling-on-all-workspace-Admins-Connect-your-Bitbucket-workspace/ba-p/3061134',
  },
  ui: {
    upgradePlan: (workspaceSlug: string) =>
      `/${workspaceSlug}/workspace/settings/plans`,
    createPackages: (workspaceSlug: string) =>
      `/${workspaceSlug}/workspace/packages/create`,
  },
};
